<template>
  <a-modal
    :title="title"
    :width="width"
    :visible="visible"
    :confirmLoading="confirmLoading"
    @ok="handleOk"
    @cancel="handleCancel"
    cancelText="关闭">
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
        <a-form-item label="基地名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <j-dict-select-tag  :disabled="true" v-decorator="[ 'baseId', validatorRules.baseId]" :trigger-change="true" dictCode="bus_inspection_general_base,base,id,status = '1'" />
        </a-form-item>
        <a-form-item label="部门名称名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <j-dict-select-tag  :disabled="true" v-decorator="[ 'departId', validatorRules.departId]" :trigger-change="true" dictCode="bus_inspection_general_base_depart,depart,id,status = '1'" />
        </a-form-item>
        <a-form-item label="区域名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-decorator="[ 'workshop', validatorRules.workshop]" placeholder="请输入区域名称"></a-input>
        </a-form-item>
        <a-form-item label="是否启用" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <j-dict-select-tag type="radio" v-decorator="['status', validatorRules.status]" :trigger-change="true" dictCode="on_off" placeholder="请选择是否启用"/>
        </a-form-item>
      </a-form>
    </a-spin>
  </a-modal>
</template>

<script>

  import { httpAction } from '@/api/manage'
  import { checkBusInspectionDepartWorkshopOfGeneral } from '@/api/api'
  import pick from 'lodash.pick'
  import JDictSelectTag from "@/components/dict/JDictSelectTag"

  export default {
    name: "BusInspectionDepartWorkshopModal",
    components: { 
      JDictSelectTag,
    },
    data () {
      return {
        form: this.$form.createForm(this),
        title:"操作",
        width:800,
        visible: false,
        model: {},
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
        validatorRules: {
          baseId: {rules: [
            {required: true, message: '请输入是否启用!'},
          ]},
          departId: {rules: [
            {required: true, message: '请输入是否启用!'},
          ]},
          workshop: {rules: [
            {required: true, message: '请输入区域名称!'},
            { validator: (rule, value, callback) => {
              if (value) {
                let  baseId=this.model.baseId
                let  departId=this.model.departId
                let params = { 
                  workshop:value,
                  baseId:baseId,
                  departId:departId
                }
                if(this.model.id){
                  params.id=this.model.id
                }
                checkBusInspectionDepartWorkshopOfGeneral(params).then(res => {
                  res.success ? callback() : callback(res.message)
                }).catch(err => {
                  callback(err.message || err)
                })
              } else {
                callback()
              }
            }},
          ]},
          status: {rules: [
            {required: true, message: '请输入是否启用!'},
          ]},
        },
        url: {
          add: "/general/workshop/busInspectionDepartWorkshop/add",
          edit: "/general/workshop/busInspectionDepartWorkshop/edit",
        }
      }
    },
    created () {
    },
    methods: {
      add (record) {
        record.status="1"
        this.edit(record);
      },
      edit (record) {
        this.form.resetFields();
        this.model = Object.assign({}, record);
        this.visible = true;
        this.$nextTick(() => {
          this.form.setFieldsValue(pick(this.model,'departId','baseId','workshop','status'))
        })
      },
      close () {
        this.$emit('close');
        this.visible = false;
      },
      handleOk () {
        const that = this;
        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
               method = 'post';
            }
            let formData = Object.assign(this.model, values);
            console.log("表单提交数据",formData)
            httpAction(httpurl,formData,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.$emit('ok');
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
              that.close();
            })
          }
         
        })
      },
      handleCancel () {
        this.close()
      },
      popupCallback(row){
        this.form.setFieldsValue(pick(row,'workshop','status'))
      },

      
    }
  }
</script>